import React, {Component} from 'react';
import strings from 'strings';
import listen from 'assets/listen.png';

import {getTestAudioPack} from './assets';
import {stopAllSounds, createHowl, playHowl} from 'utils/playSound';

class Test extends Component {
	constructor(props) {
		super(props);
		const langCode = strings.getLanguage(); // 'no' | 'nn'
		this.assets = getTestAudioPack(
			langCode,
			props.ageGroup,
			props.testKeyType
		);
	}

	componentDidMount() {
		this.initializeAudio();
	}
	componentWillUnmount() {
		this.stopSounds();
		clearTimeout(this.timeout);
	}
	componentDidUpdate(prevProps) {
		if (prevProps.currentStep !== this.props.currentStep) {
			this.startNewTask(this.props.currentStep);
		}
	}

	initializeAudio = () => {
		this.timeout = setTimeout(
			() => this.startNewTask(this.props.currentStep),
			500
		);
	};

	startNewTask = (idx) => {
		stopAllSounds();

		const src = this.assets[idx];
		if (!src) return;

		const sound = createHowl({
			src,
			onend: () => {
				sound.unload(); //  prevent memory leak
			},
		});

		playHowl(sound);
	};

	stopSounds = () => {
		stopAllSounds();
	};

	render() {
		return (
			<div className="SetningsMinne">
				<img className="listen-image" src={listen} alt="" />
			</div>
		);
	}
}
export default Test;
